import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { faTimes, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FeedbackMessageService } from '@shared/services/feedback-message.service';
import { UFeedback } from '../../interfaces/feedback-message.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-feedback-messages',
    imports: [FontAwesomeModule],
    templateUrl: './feedback-messages.component.html',
    styleUrls: ['./feedback-messages.component.css']
})
export class FeedbackMessagesComponent implements OnInit {

  constructor(private feedbackService: FeedbackMessageService, private cd: ChangeDetectorRef) { }

  @ViewChild("feedback", { static: false }) feedbackSection: ElementRef;

  messages: Array<UFeedback> = []
  icon: IconDefinition;
  timeoutHandles: Array<number> = [];

  ngOnInit(): void {
    this.icon = faTimes;

    this.feedbackService.feedbackMessage.subscribe(msg => {
      var uf: UFeedback = { key: crypto.randomUUID(), feedback: msg }
      this.messages.push(uf);

      var div = this.feedbackSection.nativeElement as HTMLDivElement;
      if (div) {
        div.style.marginBottom = "-22px";
      }

      // Remove message from Ui 10 seconds after we show it
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./feedback-messages.worker', import.meta.url));
        worker.onmessage = ({ data }) => {
          var m = this.messages.find(s => s.key == data.key);
          if (m) {
            this.messages.splice(this.messages.indexOf(m), 1);
            if (this.messages.length == 0) {
              div.style.marginBottom = "0px";
            }
          }
        };
        worker.postMessage({ msg: uf });
      } else {
        console.log("Web Workers are not supported in this environment");
      }
    });
  }

  identify(index: number, item: UFeedback): string {
    return item.key;
  }

  dismissAlert(e: MouseEvent): void {
    var button = e.currentTarget as HTMLElement;
    if (button) {
      var alert = button.parentElement;
      if (alert) {
        alert.remove();
        var div = this.feedbackSection.nativeElement as HTMLDivElement;
        if (div && this.messages.length <= 1) {
          div.style.marginBottom = "0px";
        }
      }
    }
  }
}
